import $ from 'jquery';
import AgGridColumnFilters from '../v4/components/ag_grid_column_filters';
import URI from 'urijs';
import { showModalFromUrl, initializeSaveSearch } from './search_helpers';


window.CompaniesTableView = {
  _searchObject: {},
  _gridOptions: null,
  _gridApi: null,
  _currentDataSize: 0,
  _initCall: true,

  _companyUrl(row) {
    return `/companies/${row.data.slug}`;
  },

  _companyProjectsUrl(row) {
    return `/companies/${row.data.slug}/projects`;
  },

  _companyProductsUrl(row) {
    return `/companies/${row.data.slug}/products`;
  },

  _companyNameRenderer(row) {
    return `<a href='${this._companyUrl(row)}'><b>${row.data.name_with_alias}</b></a>`;
  },

  _expertiseRenderer(row) {
    if (row.data.displaying_activities.length > 1) {
      return `${row.data.displaying_activities[0].title}(+<a href='${this._companyProjectsUrl(row)}'><b>${row.data.displaying_activities_count + 3}</b></a>)`;
    } else if (row.data.displaying_activities.length === 1) {
      return `${row.data.displaying_activities[0].title}`;
    } else {
      return '';
    }
  },

  _officesRenderer(row) {
    const count = row.data.displaying_address.count + 1;
    const {
      label
    } = row.data.displaying_address;
    if (count > 1) {
      return `${label}(+<a href='${this._companyUrl(row)}'><b>${count}</b></a>)`;
    } else if (count === 1) {
      if (label) { return label; } else { return ''; }
    }
  },

  _projectsRenderer(row) {
    return `<a href='${this._companyProjectsUrl(row)}'><b>${row.data.projects_count}</b></a>`;
  },

  _ongoingProjectsRenderer(row) {
    if (row.data.ongoing_projects_count > 0) {
      return `<b>${row.data.ongoing_projects_count}</b>`;
    } else {
      return "";
    }
  },

  _projectsValueRenderer(row) {
    return row.data.projects_value.formatted;
  },

  _ongoingProjectsValueRenderer(row) {
    return row.data.ongoing_projects_value.formatted;
  },

  _productsRenderer(row) {
    if (row.data.products.length > 0) {
      return `<a href='${this._companyProductsUrl(row)}'><b>${row.data.products.length}</b></a>`;
    } else {
      return '';
    }
  },
  _awardsRenderer(row) {
    const count = row.data.awards.length;
    if (count > 0) { return `${count}`; } else { return ''; }
  },

  _certificatesRenderer(row) {
    const count = row.data.certificates.length;
    if (count > 0) { return `${count}`; } else { return ''; }
  },

  _companyNameComparator(valueA, valueB, nodeA, nodeB) {
    const a = (nodeA.data.name_with_alias || '').toLowerCase();
    const b = (nodeB.data.name_with_alias || '').toLowerCase();
    return a.localeCompare(b);
  },

  _expertiseComparator(valueA, valueB, nodeA, nodeB) {
    const v1 = nodeA.data.displaying_activities[0] ? nodeA.data.displaying_activities[0].title : undefined;
    const v2 = nodeB.data.displaying_activities[0] ? nodeB.data.displaying_activities[0].title : undefined;
    if (!v1 && !v2) { return 0; }
    if (!v1) { return -1; }
    if (!v2) { return 1; }
    return v1.localeCompare(v2);
  },

  _officesComparator(valueA, valueB, nodeA, nodeB) {
    const v1 = nodeA.data.displaying_address.label ? nodeA.data.displaying_address.label : undefined;
    const v2 = nodeB.data.displaying_address.label ? nodeB.data.displaying_address.label : undefined;
    if (!v1 && !v2) { return 0; }
    if (!v1) { return -1; }
    if (!v2) { return 1; }
    return v1.localeCompare(v2);
  },

  _projectsComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.projects_count || 0) - (nodeB.data.projects_count || 0);
  },

  _ongoingProjectsComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.ongoing_projects_count || 0) - (nodeB.data.ongoing_projects_count || 0);
  },

  _projectsValueComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.projects_value.raw || 0) - (nodeB.data.projects_value.raw || 0);
  },

  _ongoingProjectsValueComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.ongoing_projects_value.raw || 0) - (nodeB.data.ongoing_projects_value.raw || 0);
  },

  _productsComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.products || []).length - (nodeB.data.products || []).length;
  },

  _certificatesComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.certificates || []).length - (nodeB.data.certificates || []).length;
  },

  _awardsComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data.awards || []).length - (nodeB.data.awards || []).length;
  },

  _resizeTable() {
    if (typeof resizeAgGridTable === 'function') {
      return resizeAgGridTable('#companies-table', this._gridOptions, 1, this._currentDataSize, 48);
    }
  },

  _initializeWidgets(user_id, app_id, key, index, location, activity, tag, userTag) {
    const searchParameters = {
      filters: Widgets.getCompaniesQuery(user_id, tag)
    };

    if (activity || location || userTag) {
      const tagAttributeName = `user_tags.${user_id}`;
      searchParameters['facets'] = ['state', 'activities', 'locations', tagAttributeName];
      searchParameters['facetsRefinements'] = { activities: [activity], locations: [location] };
      searchParameters['facetsRefinements'][tagAttributeName] = [userTag];
    }

    this._searchObject = SearchUtils.createInstantSearch(app_id, key, index);

    this._searchObject.use(() => ({
      onStateChange({ uiState }) {
        return uiState;
      },
      subscribe() { },
      unsubscribe() { }
    }));

    const widgets = [
      instantsearch.widgets.configure(searchParameters),
      Widgets.companiesHitsWidget(user_id)({}),
      Widgets.descriptionWidget(),
      Widgets.primaryActivitiesWidget(),
      Widgets.secondaryActivitiesWidget(),
      Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
      Widgets.statsWidget(),
      Widgets.searchBoxWidget(I18n.t('projects.keyword_filter.enter_keyword')),
      Widgets.locationWidget(),
      Widgets.quickListWidget(),
      Widgets.saveSearchWidget(),
      Widgets.clearAllWidget(),
      instantsearch.widgets.pagination({ container: '#pagination' })
    ];

    if ($('#user-tags').length > 0) { widgets.push(Widgets.userTagsWidget(user_id)); }
    if ($('#projects-location').length > 0) { widgets.push(Widgets.projectsLocationWidget()); }
    if ($('#sectors').length > 0) { widgets.push(Widgets.projectsMainSectorWidget()); }
    if ($('#sectors').length > 0) { widgets.push(Widgets.projectsSectorWidget()); }
    if ($('#budget-range').length > 0) { widgets.push(Widgets.projectsBudgetWidget()); }
    if ($('#projects-count').length > 0) { widgets.push(Widgets.projectsCountWidget()); }
    if ($('#team-size').length > 0) { widgets.push(Widgets.teamSizeWidget()); }
    if ($('#certificates').length > 0) { widgets.push(Widgets.certificatesWidget()); }

    this._searchObject.addWidgets(widgets);
    this._searchObject.start();

    this._initializeSaveSearch();

    return SearchUtils.setUpCustomListsLink('#quick-lists li > .all_list, .liked_list');
  },

  initializeTable(user_id, app_id, key, index, location, activity, tag, userTag, high_level_membership) {
    this._initializeWidgets(user_id, app_id, key, index, location, activity, tag, userTag);
    const low_level_membership = !high_level_membership;

    const columnDefs =
      [
        {
          headerName: I18n.t('companies.headers.company'),
          children: [
            { headerName: I18n.t('companies.headers.name'), tooltipField: 'name_with_alias', width: 400, cellRenderer: _.bind(this._companyNameRenderer, this), comparator: _.bind(this._companyNameComparator, this) },
            { headerName: I18n.t('companies.headers.expertise'), width: 250, cellRenderer: _.bind(this._expertiseRenderer, this), comparator: _.bind(this._expertiseComparator, this) },
            { headerName: I18n.t('companies.headers.offices'), width: 250, cellRenderer: _.bind(this._officesRenderer, this), comparator: _.bind(this._officesComparator, this) },
          ]
        },
        {
          headerName: I18n.t('companies.headers.projects'),
          children: [
            { headerName: I18n.t('companies.headers.total_projects'), width: 150, cellRenderer: _.bind(this._projectsRenderer, this), comparator: _.bind(this._projectsComparator, this) },
            { headerName: I18n.t('companies.headers.total_projects_value'), width: 150, cellRenderer: _.bind(this._projectsValueRenderer, this), comparator: _.bind(this._projectsValueComparator, this), hide: low_level_membership },
            { headerName: I18n.t('companies.headers.ongoing_projects'), width: 150, cellRenderer: _.bind(this._ongoingProjectsRenderer, this), comparator: _.bind(this._ongoingProjectsComparator, this), hide: low_level_membership },
            { headerName: I18n.t('companies.headers.ongoing_projects_value'), width: 150, cellRenderer: _.bind(this._ongoingProjectsValueRenderer, this), comparator: _.bind(this._ongoingProjectsValueComparator, this), hide: low_level_membership },
          ]
        }

      ];

    this._gridOptions = {
      headerHeight: 44,
      rowHeight: 44,
      animateRows: false,
      suppressPaginationPanel: true,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs,
      onGridReady: (e) => {
        e.api.sizeColumnsToFit();
      },
      onGridSizeChanged: (event) => {
        event.api.sizeColumnsToFit();
      }
    };

    const gridDiv = document.getElementById('companies-table');
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    // Store api on gridOptions for backward compatibility with shared components
    this._gridOptions.api = this._gridApi;
    return AgGridColumnFilters.initialize(this._gridOptions);
  },

  emptyCallHandler() {
    if (this._initCall) {
      $('.search-results-container').hide();
      $('#spinner').hide();
      return $('.empty-page').removeClass('hidden');
    }
  },

  reloadData(user_id, data) {
    this._initCall = false;
    const reloadedData = data.map(function (item) {
      if (item.follower_ids.indexOf(user_id) >= 0) {
        item.liked = true;
      }
      return item;
    });

    this._gridApi.setGridOption('rowData', data);
    this._currentDataSize = data.length;
    $('#projects-grid').parent().removeClass('hidden');
    $('.actions').removeClass('hidden');
    $('#spinner').hide();
    this._resizeTable();
    return reloadedData;
  },

  _initializeSaveSearch() {
    initializeSaveSearch({ type: 'public_companies', showSignInModal: true });
  }
};

// DOM-driven auto-init: reads config from data attributes on #companies-table.
// This runs inside the esbuild bundle and is unaffected by Sprockets crashes.
(function autoInitCompaniesTable() {
  function init() {
    var el = document.getElementById('companies-table');
    if (!el || el.getAttribute('data-auto-init') !== 'true') return;
    // Prevent double-init
    el.removeAttribute('data-auto-init');

    var userId = el.getAttribute('data-user-id') || '';
    var appId = el.getAttribute('data-app-id') || '';
    var apiKey = el.getAttribute('data-api-key') || '';
    var indexName = el.getAttribute('data-index-name') || '';
    var location = el.getAttribute('data-location') || '';
    var activity = el.getAttribute('data-activity') || '';
    var tag = el.getAttribute('data-tag') || '';
    var userTag = el.getAttribute('data-user-tag') || '';
    var highLevel = el.getAttribute('data-high-level') === 'true';

    try {
      CompaniesTableView.initializeTable(userId, appId, apiKey, indexName, location, activity, tag, userTag, highLevel);
    } catch (e) {
      console.error('[CompaniesTableView] Auto-init failed:', e.message);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
